import { CssBaseline } from '@mui/material'
import 'view/portal/loanApplication/finalDetails/_finalDetails.scss'

import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'

import * as loanStatus from 'utils/LoanStatus'
import * as variable from 'utils/Variable'

import ApiResponseWrapper from 'view/portal/components/apiResponseWrapper/Home'
import LoanProcessing from 'view/portal/components/checking/Home'
import LoanApplicationTimeout from 'view/portal/components/timeout/Home'
import HeaderNavigationWithLogin from 'view/portal/layout/HeaderNavigationWithLogin'
import UseApiRequestAuth from 'view/portal/loanApplication/finalDetails/UseApiRequest'
import DisplayDecisionContainer from 'view/portal/loanApplication/finalDetails/responseSubmitLoanApplication/Decision'

import { handleHttpErrorRedirect } from './utils/handleHttpErrorRedirect'

type Props = {
  users: {
    accountNumber: string
    deviceInformation?: string
    employer: string
    employmentPosition: string
    employmentSector: string
    employmentStatus: string
    futureChangeOfIncome: boolean
    futureChangeOfIncomeReason?: string
    futureChangeOfIncomeSpecificReason?: string
    mobileNumber: string
    reference: string
    sortCode: string
  }
}

const LoanApplicationRedirect = ({ users }: Props): JSX.Element => {
  const navigate = useNavigate()
  const {
    postSubmitLoanApplication,
    openBankingReason,
    errorResponseCode,
    loanApplicationResponse,
    postApiErrorMessage,
  } = UseApiRequestAuth()
  const [isSubmitting, setIsSubmitting] = useState<boolean>(true)
  const [flag, setFlag] = useState(true)

  useEffect(() => {
    if (flag) {
      if (users && users !== undefined) {
        postSubmitLoanApplication(users.reference, users, setIsSubmitting)
        setFlag(false)
      }
    }
  }, [flag, postSubmitLoanApplication, users])

  useEffect(() => {
    handleHttpErrorRedirect(errorResponseCode, navigate)
  }, [errorResponseCode, navigate])

  if (isSubmitting) {
    return (
      <div className="loan-status-processing">
        <HeaderNavigationWithLogin />
        <CssBaseline />
        <LoanProcessing {...{ copy: 'We are performing our checks…' }} />
      </div>
    )
  }

  // Internal Server Error (500) is handled separately from the other error status codes,
  // which are handled by the handleHttpErrorRedirect() function.
  if (errorResponseCode === variable.httpStatusCodes.internalServerError) {
    return (
      <div className="loan-status-timeout">
        <LoanApplicationTimeout />
      </div>
    )
  }

  if (postApiErrorMessage) {
    return (
      <div>
        <ApiResponseWrapper title={postApiErrorMessage} text={postApiErrorMessage} response={postApiErrorMessage}>
          <div>If you have further issues, please don't hesitate to contact our team.</div>
        </ApiResponseWrapper>
      </div>
    )
  }

  if (
    loanApplicationResponse?.decision === loanStatus.StatusReferred ||
    loanApplicationResponse?.decision === loanStatus.StatusApproved ||
    loanApplicationResponse?.decision === loanStatus.StatusDeclined
  ) {
    return (
      <DisplayDecisionContainer
        loanApplicationResponse={loanApplicationResponse}
        openBankingReason={openBankingReason}
      />
    )
  }

  return (
    <div className="loan-status-processing">
      <LoanProcessing {...{ copy: 'We are performing our checks…' }} />
    </div>
  )
}

export default LoanApplicationRedirect
